import { http } from "./http";

export const TICKET_STATUS_LABELS = {
  OPEN: "Aberto",
  IN_PROGRESS: "Em andamento",
  WAITING_REQUESTER: "Aguardando solicitante",
  RESOLVED: "Resolvido",
  CLOSED: "Fechado",
  CANCELLED: "Cancelado",
  REOPENED: "Reaberto",
  ARCHIVED: "Arquivado",
};

function parseApiError(error) {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.error) return String(data.error);
  if (data?.message) return String(data.message);
  const status = error?.response?.status;
  if (status === 403) {
    return "Acesso negado. Seu usuário precisa ser agente de suporte (SUPPORT_AGENT_UIDS ou is_support_agent).";
  }
  if (status === 401) return "Não autenticado. Faça login novamente.";
  return error?.message || "Erro na API de chamados.";
}

export async function isSupportAgent() {
  try {
    const { data } = await http.get("/api/iam/me/support-agent");
    return Boolean(data?.supportAgent);
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

export async function getTicketModules() {
  try {
    const { data } = await http.get("/api/iam/tickets/modules");
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

export async function listTickets({
  scope = "all",
  status,
  moduleCode,
  companyId,
  page = 0,
  size = 50,
} = {}) {
  try {
    const { data } = await http.get("/api/iam/tickets", {
      params: {
        scope,
        status: status || undefined,
        moduleCode: moduleCode || undefined,
        companyId: companyId || undefined,
        page,
        size,
      },
    });
    return data || { content: [], totalElements: 0 };
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

export async function getTicketById(id) {
  try {
    const { data } = await http.get(`/api/iam/tickets/${id}`);
    return data;
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

export async function addTicketComment(id, body, files = []) {
  const form = new FormData();
  form.append("body", body);
  (files || []).forEach((f) => form.append("files", f));
  try {
    const { data } = await http.post(`/api/iam/tickets/${id}/comments`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

export async function changeTicketStatus(id, status, assigneeId) {
  try {
    const body = { status };
    if (assigneeId) body.assigneeId = assigneeId;
    const { data } = await http.patch(`/api/iam/tickets/${id}/status`, body);
    return data;
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}
